import * as React from 'react';
import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitContextProvider, UiKitToastsContextProvider } from '@cian/ui-kit/context';
import { Provider } from 'react-redux';

import { IApplicationContext } from 'shared/types/applicationContext';
import { EPageType } from 'shared/types/pageType';
import { TReduxStore } from 'shared/types/redux';
import { ApplicationContext } from 'shared/utils/applicationContext';
import { DobroFormContainer } from '../DobroFormContainer';
import { DobroListingContainer } from '../DobroListingContainer';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
}

export const Application: React.FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { initialDeviceType, pageType },
  } = context;

  const PageContainer = {
    [EPageType.DobroForm]: DobroFormContainer,
    [EPageType.DobroObjects]: DobroListingContainer,
  }[pageType];

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitContextProvider deviceType={initialDeviceType}>
          <UiKitToastsContextProvider>
            <Provider store={reduxStore}>
              <PageContainer />
            </Provider>
          </UiKitToastsContextProvider>
        </UiKitContextProvider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
